import {OrderStates, useClient, useDictionary} from '@adamlip/okeoke.client';
import Icon from 'assets/icons';
import LocationClosedModal from 'components/Modals/LocationClosedModal';
import {MainContext} from 'contexts/MainContext';
import useBasket from 'hooks/useBasket';
import {useContext, useEffect, useRef, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {v4 as uuidv4} from 'uuid';
import LoginModal from 'views/Login';
import MoreMenuModal from 'components/MoreModal';
import SelectTableModal from 'components/SelectTableModal';
import SelectLanguageModal from 'components/SelectLanguageModal';
import {useLocation} from 'react-router-dom';
import {AppParamsContext} from 'contexts/AppParamsContext';
import IconComponent from 'components/IconComponent';

function TopBar() {
  const {getValue, dictionary} = useDictionary();
  const {itemCount, orderState, discountPrice} = useBasket();
  const {addModal, popModal, handleClickCart} = useContext(MainContext);
  const {languageCode, languages, locations, brandID} = useClient();
  const {appParams} = useContext(AppParamsContext);
  const location = useLocation();

  const langRef = useRef(null);
  const timer = useRef(null);
  const [loginOpen, setLoginOpen] = useState(false);
  const [openLanguageModal, setOpenLanguageModal] = useState(false);
  const [moreMenuModalOpen, setMoreMenuModalOpen] = useState(false);
  const [selectTableOpen, setSelectTableOpen] = useState(false);

  useEffect(() => {
    if (appParams != null && appParams?.showLocationClosedWindow) {
      timer.current = setTimeout(() => {
        const locationsArray = Object.values(locations || {});
        if (locationsArray.length === 1 && locationsArray[0].openState.open === false) {
          addModal(<LocationClosedModal key={uuidv4()} getValue={getValue} popModal={popModal} />);
        }
      }, 3000);
    }

    return () => {
      clearTimeout(timer.current);
    };
    // eslint-disable-next-line
  }, [locations, dictionary, appParams]);

  let navigate = useNavigate();

  const handleClickHome = () => {
    navigate('/');
  };

  const handleClickLogo = () => {
    if (appParams?.defaultUrl != null && appParams?.defaultUrl !== '') {
      navigate(appParams?.defaultUrl);
    } else {
      navigate('/');
    }
  };

  const handleClickBack = () => {
    navigate(-1);
  };

  const getNavElement = (element) => {
    if (element?.type == null) return null;
    if (element?.type === 'system') {
      if (element?.name != null) {
        switch (element?.name) {
          case 'back':
            return (
              <div className='topBar-element topBar-svg topBar-backIcon' onClick={handleClickBack}>
                <div className='w-10 h-10'>
                  <Icon
                    name={element?.icon != null ? element?.icon : 'back'}
                    className={'stroke-[var(--top-bar-icon-color)]'}
                    secondClassName={'fill-[var(--top-bar-icon-color)]'}
                  />
                </div>
              </div>
            );
          case 'home':
            return (
              <div className='topBar-element topBar-svg topBar-homeIcon' onClick={handleClickHome}>
                <div className='w-10 h-10'>
                  <Icon
                    name={element?.icon != null ? element?.icon : 'setHome'}
                    className={'stroke-[var(--top-bar-icon-color)]'}
                    secondClassName={'fill-[var(--top-bar-icon-color)]'}
                  />
                </div>
              </div>
            );
          case 'basketValue':
            return (
              <div className='topBar-element topBar-cart-root' onClick={handleClickCart}>
                <div className='topBar-cartText font-smallest'>{getValue('app_v2_topBar_cartText')}</div>
                <div className='topBar-cartPrice font-small'>
                  <span className='topBar-cartPrice-value'>{itemCount > 0 && orderState === OrderStates.BASKET ? discountPrice : 0}</span>
                  <span className='topBar-cartPrice-currency'>Ft</span>
                </div>
              </div>
            );
          case 'basket':
            return (
              <div className='topBar-element topBar-svg topBar-cartIcon ' onClick={handleClickCart}>
                {/* GERGŐ EZT MAJD TÖRÖLD */}
                {brandID === 'pbz9fdc3' ? (
                  <div className='w-7 h-7'>
                    <Icon name={'setCart2'} className={'stroke-[var(--top-bar-icon-color)] stroke-1'} secondClassName={'fill-[var(--top-bar-icon-color)]'} />
                  </div>
                ) : brandID === '5251snop' ? (
                  <div className='w-7 h-7'>
                    <Icon name={'cocktail'} className={'stroke-[var(--top-bar-icon-color)] stroke-1'} secondClassName={'fill-[var(--top-bar-icon-color)]'} />
                  </div>
                ) : (
                  <div className='w-6 h-6'>
                    <Icon
                      name={element?.icon != null ? element?.icon : 'setCart'}
                      className={'stroke-[var(--top-bar-icon-color)] stroke-1'}
                      secondClassName={'fill-[var(--top-bar-icon-color)]'}
                    />
                  </div>
                )}
                {<div className={`cart-badge ${itemCount > 0 && orderState === OrderStates.BASKET ? 'visible' : 'not-visible'}`}>{itemCount}</div>}
              </div>
            );
          case 'language':
            return (
              <div className='topBar-element' ref={langRef} onClick={() => setOpenLanguageModal(true)}>
                {appParams?.styles?.languages?.[languages?.[languageCode?.toUpperCase()]?.flagCode || 'hu'] ? (
                  <IconComponent iconCode={appParams?.styles?.languages?.[languages?.[languageCode?.toUpperCase()]?.flagCode || 'hu']} />
                ) : (
                  <img src={`https://cdn.okeoke.io/global/flags/${languages?.[languageCode?.toUpperCase()]?.flagCode || 'hu'}.svg`} alt='enflag' className='w-full h-full' />
                )}
              </div>
            );
          default:
            return null;
        }
      }
    } else {
      if (element?.type === 'custom') {
        return (
          <div
            className='topBar-element topBar-svg'
            onClick={() => {
              navigate(element?.path || '/');
            }}>
            <div className='w-6 h-6'>
              <Icon
                name={element?.icon != null ? element?.icon : 'homeIcon'}
                className={'stroke-[var(--top-bar-icon-color)] '}
                secondClassName={'fill-[var(--top-bar-icon-color)]'}
              />
            </div>
          </div>
        );
      } else return <div className='topBar-element'></div>;
    }
  };

  if (location.pathname.startsWith('/menu')) return null;

  if (appParams?.styles?.topBottomBar?.topBarVisible == null || appParams?.styles?.topBottomBar?.topBarVisible === false) return null;

  return (
    <>
      {loginOpen && <LoginModal isOpen={loginOpen} setIsOpen={setLoginOpen} />}
      <SelectTableModal isOpen={selectTableOpen} setIsOpen={setSelectTableOpen} />
      <MoreMenuModal isOpen={moreMenuModalOpen} setIsOpen={setMoreMenuModalOpen} />
      <section className='topBar-root'>
        {appParams?.navigation?.topBarElements != null && appParams?.navigation?.topBarElements.length > 0 && getNavElement(appParams?.navigation?.topBarElements[0])}
        {appParams?.navigation?.topBarElements != null && appParams?.navigation?.topBarElements.length > 1 && getNavElement(appParams?.navigation?.topBarElements[1])}
        <div className='topBar-element topBar-svg topBar-brandLogo' onClick={handleClickLogo}>
          <img src={appParams?.assets?.brandLogo} alt='logo' />
        </div>
        {appParams?.navigation?.topBarElements != null && appParams?.navigation?.topBarElements.length > 2 && getNavElement(appParams?.navigation?.topBarElements[2])}
        {appParams?.navigation?.topBarElements != null && appParams?.navigation?.topBarElements.length > 3 && getNavElement(appParams?.navigation?.topBarElements[3])}
      </section>
      <SelectLanguageModal isOpen={openLanguageModal} onOpenChange={() => setOpenLanguageModal(false)} />
    </>
  );
}

export default TopBar;
